import { capitalize, pluralize } from "@theprelude/core";
import { DropdownSelect } from "../dropdown-select";

export function Filter({
  label,
  options,
  selection,
  onChangeSelection,
}: {
  label: string;
  options: string[];
  selection: Set<string>;
  onChangeSelection: (selection: Set<string>) => void;
}) {
  const selectedCount = selection.size;

  return (
    <DropdownSelect
      intent="pill"
      size="tiny"
      multiple
      options={options}
      placeholder={`Search by ${label}`}
      getLabel={(o) => o}
      getValue={(o) => o}
      selection={selection}
      onChangeSelection={onChangeSelection}
    >
      {selectedCount === 0 || selectedCount === options.length
        ? "All"
        : `${selectedCount} ${pluralize(selectedCount, capitalize(label))}`}
    </DropdownSelect>
  );
}
